export default __webpack_public_path__ + "static/media/goshen76.8ab82dd2.jpg";